import { Component } from '@angular/core';
import { StateService } from '@app/core/services/state.service';

@Component({
    selector: 'tt-doc-article-view',
    templateUrl: './doc-article-view.component.html',
    styleUrls: ['./doc-article-view.component.css'],
})
export class DocArticleViewComponent {
    public params: { docarticle_keyno: string };

    constructor(private state: StateService) {
        this.params = state.getStateParams() as { docarticle_keyno: string };
    }

    public onSubmit(event: { back: number }) {
        this.state.back(event.back);
    }
}
